import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  grouped?: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    table: {
      minWidth: 750,
      borderBottom: `1.9px solid ${theme.oysterTheme.stone}`,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      width: '100%',
      marginBottom: ({ grouped }) => (grouped ? '10px' : '0px'),
      '& > div': {
        backgroundColor: `${theme.oysterTheme.cotton} !important`,
      },
    },
    accordionContainer: {
      width: '100%',
    },
    accordionDetailsContainer: {
      padding: 0,
    },
    accordionSummaryContainer: {
      padding: 0,
      '& > div': {
        margin: '0px !important',
      },
      width: '100%',
    },
    accordionGroupedSummaryContainer: {
      paddingLeft: 25,
      paddingRight: 0,
      '& > div': {
        margin: '0px !important',
      },
      background: theme.oysterTheme.pearl,
      width: '100%',
      borderRadius: 14,
    },
    titleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
      display: 'flex',
      alignItems: 'center',
    },
    subtitleStep: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '14px',
      color: theme.oysterTheme.charcoal,
      margin: '0 0  0 37px',
      paddingBottom: 26,
    },
    totalLeftAmountContainer: {
      textAlign: 'right',
    },
    resumeContainer: {
      padding: '20px',
      '& > div': {
        opacity: '1 !important',
      },
    },
    tableContainer: {
      maxHeight: 610,
      overflow: 'auto',
      '& thead > tr > th': {
        borderTop: '2px solid #EEF0F2',
        borderBottom: '2px solid #EEF0F2',
      },
    },
    totalAmount: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    totalAmountCurrency: {
      fontSize: '14px',
    },
    tableHead: {
      background: theme.oysterTheme.pearl,
      borderTop: `1.9px solid ${theme.oysterTheme.stone}`,
    },
    tableHeadCell: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      color: `${theme.oysterTheme.pine} !important`,
      fontSize: '0.9rem !important',
      borderBottom: `1.9px solid ${theme.oysterTheme.stone} !important`,
    },
    tableBodyCell: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      color: '#677685 !important',
      border: '0 !important',
    },
    tableBodyCellUnselected: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      color: '#B0B6C2 !important',
      border: '0 !important',
    },
    rowsCounter: {
      background: 'rgba(24, 144, 255, 0.10)',
      color: '#1890FF',
      fontSize: '0.9rem',
      fontWeight: 500,
      borderRadius: 12,
      padding: '2px 8px 2px 8px',
    },
    chipSuccess: {
      border: '0 !important',
      color: '#18BA81 !important',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      '& > svg': {
        fontSize: '1rem !important',
        color: '#18BA81 !important',
      },
    },
    chipError: {
      border: '0 !important',
      color: `${theme.oysterTheme.ferrari} !important`,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      '& > svg': {
        fontSize: '1rem !important',
        color: `${theme.oysterTheme.ferrari} !important`,
      },
    },
    chipOnProcess: {
      border: '0 !important',
      color: '#1375CF !important',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      '& > svg': {
        fontSize: '1rem !important',
        color: '#1375CF !important',
      },
    },
    chipCanceled: {
      border: '0 !important',
      color: '#B0B6C2 !important',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      '& > svg': {
        fontSize: '1rem !important',
        color: '#B0B6C2 !important',
      },
    },
    chipCep: {
      cursor: 'pointer !important',
      border: '0 !important',
      color: '#1375CF !important',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
      fontSize: '0.9rem !important',
      '& > svg': {
        fontSize: '1rem !important',
        color: '#1375CF !important',
      },
    },
    rowError: {
      paddingLeft: '5px',
      marginLeft: '18px',
      marginRight: '18px',
      background: 'rgba(249, 90, 89, .10)',
      borderRadius: '4px',
      marginBottom: 5,
    },
  }),
);

export default useStyles;
